export default __webpack_public_path__ + "static/media/mr_mrs_smith_m3.116649eb.png";